/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

const MIN_VALUE = 0

export const clamp = (value: number, max: number) => Math.min(Math.max(value, MIN_VALUE), max)
